export default __webpack_public_path__ + "static/case-4-f814bb4af2bb754f29e5e9b94547754c.webp";